export const generateSymbolColors = (symbols) => {
    const colorMap = {};
    const total = symbols.length;
  
    symbols.forEach((symbol, index) => {
      const hue = Math.round((360 / total) * index);
      colorMap[symbol] = `hsl(${hue}, 65%, 55%)`;
    });
  
    return colorMap;
  };
  
